import styled from 'styled-components';
import { getComponentOverride } from './utils';
import { theme } from '../../theme';
const { text, colors, fontFamily } = theme;
export const Text = styled.span.attrs(({ as, variant }) => ({
    as: getComponentOverride(as, variant),
})).withConfig({ displayName: "vui--Text", componentId: "vui--p74sf8" }) `box-sizing:border-box;display:inline-block;margin:0;padding:0;font-style:normal;font-weight:normal;font-size:12px;font-family:${fontFamily};line-height:16px;color:#37424d;${({ variant }) => (variant === 'button' || variant === 'buttonSmall') &&
    `
    cursor: pointer;
    background-color: transparent;
    border: 0;
  `} ${({ variant, muted = false }) => {
    if (!variant)
        return '';
    const color = muted ? colors.neutral.ink.lightest : text[variant].color;
    return `
      font-family: ${text[variant].fontFamily};
      font-style: ${text[variant].fontStyle};
      font-weight: ${text[variant].fontWeight};
      font-size: ${text[variant].fontSize};
      line-height: ${text[variant].lineHeight};
      color: ${color};
      text-decoration: ${text[variant].textDecoration};
      letter-spacing: ${text[variant].letterSpacing};
    `;
}}`;
//# sourceMappingURL=Text.js.map